export default {"src":"/_next/static/media/integrated-marketing-icon.ae3f566d.svg","height":137,"width":139,"blurWidth":0,"blurHeight":0};